import { LabelImportantOutlined } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';

export default function IntroTab() {
    return (
        <>
        <Grid2 xs={12} sm={6}>
            <Box className='centered-container mcc-tabinfo'>
            <Stack spacing={1} textAlign={'center'}>
                <Typography variant='h4' sx={{ fontWeight: '500 !important' }} color={"var(--mcc-contrast1)"}>
                    SGFIN MICE<br/>Carbon Calculator
                </Typography>
                <br/>
                <Typography variant='body2'>
                Planning an event? Let's find out how green it is.
                <br/>
                <br/>
                This calculator will help you estimate the carbon footprint of your MICE (meetings, incentives, conferences, and exhibitions) event — and identify where the biggest emissions come from.
                </Typography>
            </Stack>
            </Box>
        </Grid2>
        <Grid2 xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'column' }}>
        <Stack spacing={2} sx={{ p: 2, flexGrow: 1 }}>
            <Typography variant='h6'>
                What you need to do
            </Typography>

            <Typography variant="body2" component="div">
                <ul>
                    <li>
                        If you have exact numbers (like number of attendees or hotel nights), enter them directly.
                    </li>
                    <li>
                        If you don't, just pick the closest estimate from the available dropdown options.
                    </li>
                    <li>
                        ⚠️ <b>Important</b>: If a quantity is zero, please key in “0”.
                        Leaving it blank may trigger default values — which can skew your results!
                    </li>
                </ul>
            </Typography>

            
            <Typography variant='h6'>
                Results you will get
            </Typography>
            <Typography variant="body2" component="div">
                ✅ Total emissions (in tonnes of CO₂e)
                <br/>
                ✅ Carbon footprint per capita per day
                <br/>
                ✅ A breakdown by category:
                <ul>
                    <li>
                    🏢 On-site Activities
                    </li>
                    <li>
                    ✈️ Transportation
                    </li>
                    <li>
                    🛏️ Accommodations
                    </li>
                </ul>

                &emsp;&emsp;All benchmarked against a typical MICE event in the U.S.
            </Typography>
        </Stack>
        
        <Box sx={{ backgroundColor: 'var(--bg-green)', p: 1, color: '#00470F', borderRadius: '0 0 12px 0' }}>
            <Typography fontWeight={700}><LabelImportantOutlined fontSize='inherit' /> Ready to get started?</Typography>
            <Typography variant='body2'>
                Click <b>Next</b> to begin entering general information about your event.
            </Typography>
        </Box>
        </Grid2>
        </>
    )
}